export const focus = {
  inserted(el) {
    el.focus()
  }
}

// export default {
//   focus(vue) {
//     return {
//       inserted(el) {
//         vue.nextTick(() => el.focus())
//       }
//     }
//   }
// }
